//angular imports
import { ChangeDetectionStrategy, Component } from '@angular/core';


//local imports
import { CloseDialogMessage, CommandModel, Messenger } from '@app/shared';
import { DepartmentGroupDetails } from '@app/catalog';

@Component({
  selector: 'add-department-group',
  standalone: false,
  templateUrl: './add-department-group.component.html',
  styleUrl: './add-department-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddDepartmentGroupComponent {
  public details = DepartmentGroupDetails.empty();
  
  

  public cancelCommand = new CommandModel({
    executeAction: () => {
      this.messenger.send(new CloseDialogMessage());
      return Promise.resolve();
    },
  });

  public submitCommand = new CommandModel({
    executeAction: () => this.save(),
    isValid: this.details.isValid,
  });

  constructor(
    private messenger: Messenger,
  ) {}

  private save = async () => {
  };
}
